module.exports = __webpack_public_path__ + "static/media/cafe-la-org-bolsa-marron-ok.4354f68b.jpg";